import { BirthdayDateModal, RangeDateModal } from '@/shared/components/calendar';
import { useModalStore } from '@/shared/lib';

type Params = {
  onBack: () => void;
  onApply: (dateFrom?: Date, dateTo?: Date) => void;
  isSingle?: boolean;
  initDate?: Date;
};

export function useDateModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openDateModal = ({ onBack, onApply, isSingle, initDate }: Params) => {
    showDialogComponent({
      component: isSingle ? (
        <BirthdayDateModal initDate={initDate} onApply={onApply} />
      ) : (
        <RangeDateModal initDate={initDate} onApply={onApply} />
      ),
      className:
        'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex rounded-[3.2rem]',
      onClose: onBack,
    });
  };

  return { openDateModal, closeDialog };
}
